import { createResource, type Match, type Query } from '@atlassian/react-resource-router';
import { getProjectKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import { performGetRequest } from '@atlassian/jira-fetch';
import { createResourceError } from '@atlassian/jira-router-resources-utils/src/utils/create-resource-error/index.tsx';
import { NOT_FOUND } from '@atlassian/jira-common-constants/src/http-status-codes.tsx';

// We use 1/0 to reduce characters as user preferences has a 255 limit
export type IssueCollapsibleGroupData = {
	1: string[]; // expanded group ids
	0: string[]; // collapsed group ids
};

const getKey = ({ match, query }: { match: Match; query: Query }) => {
	const projectKey = getProjectKey(match, query);
	return `issue.collapsible-group.${projectKey}`;
};

export const issueCollapsibleGroupDataResource = createResource<
	IssueCollapsibleGroupData | undefined
>({
	type: 'ISSUE_COLLAPSIBLE_GROUP_DATA',
	getKey,
	getData: async ({ match, query }) => {
		const key = getKey({ match, query });
		const requestUrl = `/rest/api/3/mypreferences?key=${key}`;

		try {
			return await performGetRequest(requestUrl);
		} catch (error) {
			if (
				!!error &&
				typeof error === 'object' &&
				'statusCode' in error &&
				error.statusCode === NOT_FOUND
			) {
				return;
			}

			throw createResourceError(
				{
					component: 'spa.view.routes.issue-view.collapsible-group.getData',
					message: 'An error was thrown while prefetching issue collapsible group data',
				},
				error,
			);
		}
	},
});
